export default __webpack_public_path__ + "static/media/DEXYNTHLogo.3bd9463f.svg";